jQuery(document).ready(function() {
  getHeaderHeight();
});
function getHeaderHeight(){
  var classHeaderHeight = jQuery('.section-header-announcements').height();
  document.documentElement.style.setProperty('--announcement-height', classHeaderHeight + 'px');
}
jQuery(window).on('resize', function () {
  getHeaderHeight();
})

// REVIEW SLIDER -- START

$(document).ready(function () {
    $('.review__slider').slick({
      slidesToShow: 2.2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      arrows: false,
      dots: false,
      vertical: false,
      speed: 8000,
      pauseOnHover: false,
      cssEase: 'linear',
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1.3,
            vertical: false
          }
        }
      ]
    });

    $('.review__slider_reverse').slick({
      slidesToShow: 2.2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      arrows: false,
      dots: false,
      vertical: false,
      speed: 8000,
      pauseOnHover: false,
      cssEase: 'linear',
      rtl: true,
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1.3,
            vertical: false
          }
        }
      ]
    });
});

$(document).ready(function () {
  if (window.innerWidth >= 749) {
    // const swiper1 = new Swiper(".review__slider", {
    //   direction: 'vertical',
    //   loop: true,
    //   slidesPerView: 2.5,
    //   speed: 8000,
    //   allowTouchMove: false,
    //   spaceBetween: 20,
    //   autoplay: {
    //     delay: 0,
    //   },
    // });
    // const swiper2 = new Swiper(".review__slider_reverse", {
    //   direction: 'vertical',
    //   loop: true,
    //   slidesPerView: 2.5,
    //   speed: 8000,
    //   allowTouchMove: false,
    //   spaceBetween: 20,
    //   autoplay: {
    //     delay: 0,
    //     reverseDirection: true
    //   },
    // });
    (function($) {
      class InfiniteMarquee {
        constructor($container, direction, speed) {
          this.$container = $container;
          this.$track = $container.find('.marquee-track');
          this.direction = direction;
          this.speed = speed;
          this.offset = 0;
          this.totalHeight = 0;
    
          if (this.$track.length) {
            this.prepare();
            this.cloneTrack();
            this.animate();
          }
        }
    
        prepare() {
          const containerHeight = this.$container.height();
          let currentHeight = this.$track[0].scrollHeight;
    
          // Duplicate children until height > 2x container height
          while (currentHeight < containerHeight * 2) {
            this.$track.append(this.$track.children().clone(true));
            currentHeight = this.$track[0].scrollHeight;
          }
    
          this.totalHeight = currentHeight;
        }
    
        cloneTrack() {
          this.$clone = this.$track.clone(true).addClass('marquee-clone');
          this.$container.append(this.$clone);
        }
    
        animate() {
          this.offset += this.speed;
          if (this.offset >= this.totalHeight) this.offset = 0;
    
          const y = this.direction === 'up' ? -this.offset : this.offset;
    
          this.$track.css('transform', `translateY(${y}px)`);
          this.$clone.css('transform', `translateY(${y - this.totalHeight}px)`);
    
          requestAnimationFrame(() => this.animate());
        }
      }
    
      $.fn.infiniteMarquee = function() {
        return this.each(function() {
          const $el = $(this);
          const dir = $el.data('direction') || 'up';
          const spd = parseFloat($el.data('speed')) || 0.5;
    
          new InfiniteMarquee($el, dir, spd);
        });
      };
    
      $(document).ready(function() {
        $('.marquee-column').infiniteMarquee();
      });
    })(jQuery);
  }
});

// REVIEW SLIDER -- END

// PRODUCT FEATURES -- START
  $(document).ready(function() {
      // Click event on accordion header
      $('.accordion-header').click(function() {
          // Get the accordion body
          const body = $(this).next('.accordion-body');
          
          // Check if this accordion is already open
          const isOpen = $(this).hasClass('active');
          
          // Close all other accordions
          $('.accordion-header').removeClass('active');
          $('.accordion-body').slideUp(300);
          
          // If it wasn't open, open this one
          if (!isOpen) {
              $(this).addClass('active');
              body.slideDown(300);
          }
      });
  });
// PRODUCT FEATURES -- START

/***************** Wishlist Code start here *****************/
// Wishlist feature: Add or remove the current product from the wishlist
jQuery(document).on("click", ".wishlist_button", function () {
  var flag='';
  if(jQuery(this).hasClass('remove_wishlist_product')){
    flag=1;
  }
  toggleWishlist(jQuery(this),flag);
});

function toggleWishlist(objClick, flag = "") {
  var optionAllval = "";
  var productId = objClick.attr("data-pid");
  var ptitle = objClick.attr("data-ptitle");
  var pimage = objClick.attr("data-pimage");
  var pprice = objClick.attr("data-pprice");
  var cpprice = objClick.attr("data-cpprice");
  var pslug = objClick.attr("data-pslug");
  var productVendor = objClick.attr("data-vendor");
  var productUrl = objClick.attr("data-url");
  if (productUrl && productUrl.includes("?")) {
    productUrl = productUrl.split("?")[0];
  }
  var productSku = objClick.attr("data-sku");
  var priceNormal = objClick.attr("data-pricenormal");
  if (priceNormal == "" || priceNormal == undefined) {
    priceNormal = 0;
  }
  var variantId = objClick.attr("data-variantid");
  var cppriceNormal = objClick.attr("data-cppricenormal");
  if (cppriceNormal == "" || cppriceNormal == undefined) {
    cppriceNormal = 0;
  }
  //console.log("variantId", variantId);
  const pdpData = {
    product_title: ptitle,
    product_image: pimage,
    product_price: pprice,
    product_url: productUrl,
    variant_id:variantId,
    product_id:productId,
    price_normal:priceNormal,
    product_vendor:productVendor,
    compare_normal:cppriceNormal
  };

  let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  const isAlreadyInWishlist = wishlistData.some(
    (item) => item.variant_id === pdpData.variant_id
  );
  const wishlistButton = document.getElementsByClassName("wishlist_button")[0];
  //console.log("isAlreadyInWishlist",isAlreadyInWishlist);
  if (!isAlreadyInWishlist) {
    wishlistData.push(pdpData);
    localStorage.setItem("wishlist", JSON.stringify(wishlistData));
    // alert('Product added to wishlist:', pdpData.productTitle);
    if (flag == "") {
      wishlistButton.innerHTML = `<svg class="heart-filled" width="35px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
      </svg>`;
    }
  } else {
    wishlistData = wishlistData.filter(
      (item) => item.variant_id !== pdpData.variant_id
    );
    localStorage.setItem("wishlist", JSON.stringify(wishlistData));
    // alert('Product removed from wishlist:', pdpData.productTitle);
    if (flag == "") {
      wishlistButton.innerHTML = `<svg class="heart-outline" width="40px" height="40px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="0" fill="none" width="24" height="24"/><g><path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/></g></svg>`;
    }
  }
  // Update the display after modifying the wishlist
  //displayWishlist();
  addedWishListFill();
  if(jQuery('.header__icon-wishlist').find('.wishlist-count').length>0){
    jQuery('.header__icon-wishlist').find('.wishlist-count').text('('+wishlistData.length+')');
  }
  if (flag != "") {
    displayWishlist();
  }

}

//Remove the specified product from the wishlist
function removeFromWishlist(variantId) {
  let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  wishlistData = wishlistData.filter((item) => item.variant_id !== variantId);
  localStorage.setItem("wishlist", JSON.stringify(wishlistData));
  // Update the display after removing from the wishlist
  displayWishlist();
}

// Display wishlist items
function displayWishlist() {
  const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  //if(jQuery('.js-wishlistBlock').length!=0){
  const wishlistBlock = document.querySelector(".js-wishlistBlock");
  if (wishlistData.length === 0 && wishlistBlock!=null) {
    console.log("Wishlist is empty");
    wishlistBlock.innerHTML = "Wishlist is empty";
    wishlistBlock.classList.add('is-empty-wishlist');
    return;
  }else if(jQuery('.header__icon-wishlist').find('.wishlist-count').length>0){
    jQuery('.header__icon-wishlist').find('.wishlist-count').text('('+wishlistData.length+')');
  }

  var loaderHtml = '<div class="loading-overlay__spinner hidden">';
  loaderHtml +=
    '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">';
  loaderHtml +=
    '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>';
  loaderHtml += "</svg>";
  loaderHtml += "</div>";
  const wishlistHtml = wishlistData
    .map((item) => {
      return `<li class="grid__item">
      <div class="wishlist-product__list card-wrapper product-card-wrapper underline-links-hover">
         <div class="card card--standard card--media" style="--ratio-percent: 125.0%;">
          <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 125.0%;">
            <div class="card__media">
              <div class="media media--transparent media--hover-effect">
                <a href="${item.product_url}">
                    <img src="${item.product_image}" alt="${item.product_title}">
                </a>
              </div>
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              <div class="card__information_top">
                <div class="card__information_left">
                  <h3 class="card__heading h5" >
                    <a href="${item.product_url}" class="full-unstyled-link">
                    ${item.product_title}
                    </a>
                  </h3>
                  <div class="card-information"><span class="visually-hidden">Vendor:</span>
                      <div class="caption-with-letter-spacing light visually-hidden">${item.product_vendor}</div>
                        <div class="price">
                            <span class="price-item price-item--regular">
                              ${item.product_price}
                            </span>
                      </div>
                  </div>
                </div>
                <button
                  class="product-wish-btn wishlist_button remove_wishlist_product"
                  data-url="${item.product_url}"
                  data-pimage="${item.product_image}"
                  data-pprice="${item.product_price}"
                  data-pricenormal="${item.price_normal}"
                  data-cppricenormal="${item.compare_normal}"
                  data-ptitle="${item.product_title}"
                  data-pid="${item.product_id }"
                  data-vendor="${item.product_vendor}"
                  data-variantid="${item.variant_id}"
                >
                  <svg class="heart-filled" width="35px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
                  </svg>
                </button>
              </div>
              <div class="quick-add no-js-hidden">
                <product-form-component data-section-id="template--19220073709745__product_list_3Uyb9k" data-product-id="${item.product_id }" data-product-url="${item.product_url}" on:submit="/handleSubmit">
                  <div class="visually-hidden" aria-live="assertive" role="status" aria-atomic="true" ref="liveRegion"></div>
                  <form method="post" action="/cart/add" id="BuyButtons-ProductForm-ASjViR1lsMWV0ZVpne__buy_buttons_P3F6B3" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                      <input type="hidden" name="form_type" value="product">
                      <input type="hidden" name="utf8" value="✓">
                      <input type="hidden" name="id" ref="variantId" value="${item.variant_id}">
                      <div class="product-form-buttons spacing-style product-form-buttons--stacked" style="--padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px;">
                        <span style="--add-to-cart-font-case: ;">
                            <add-to-cart-component ref="addToCartButtonContainer" data-product-variant-media="${item.product_image}">
                              <button id="BuyButtons-ProductSubmitButton-AcDNCZkppN1dpKzVlT__add-to-cart" type="submit" data-vid="${item.variant_id}" name="add" ref="addToCartButton" on:click="/handleClick" class="button add-to-cart-button button-secondary">
                                  <span class="add-to-cart-text">
                                    <span class="svg-wrapper add-to-cart-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                                          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"></path>
                                          <path stroke="currentColor" stroke-linecap="round" stroke-width="var(--icon-stroke-width)" d="M14.608 12.563v5m2.5-2.5h-5"></path>
                                        </svg>
                                    </span>
                                    <span class="add-to-cart-text__content">Add to cart</span>
                                  </span>
                                  <span aria-hidden="true" class="add-to-cart-text--added">
                                    <span class="svg-wrapper add-to-cart-icon--added">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-checkmark">
                                          <path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                    <span class="">Added</span>
                                  </span>
                              </button>
                            </add-to-cart-component>
                        </span>
                        <span class="product-form-text__error hidden" ref="addToCartTextError">
                            <span class="svg-wrapper product-form-icon--error">
                              <svg class="icon icon-error" viewBox="0 0 13 13">
                                  <circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="var(--icon-stroke-width)"></circle>
                                  <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"></circle>
                                  <path fill="#fff" d="m5.874 3.528.1 4.044h1.053l.1-4.044zm.627 6.133c.38 0 .68-.288.68-.656s-.3-.656-.68-.656-.681.288-.681.656.3.656.68.656"></path>
                                  <path fill="#fff" stroke="#EB001B" stroke-width=".7" d="M5.874 3.178h-.359l.01.359.1 4.044.008.341h1.736l.008-.341.1-4.044.01-.359H5.873Zm.627 6.833c.56 0 1.03-.432 1.03-1.006s-.47-1.006-1.03-1.006-1.031.432-1.031 1.006.47 1.006 1.03 1.006Z"></path>
                              </svg>
                            </span>
                        </span>
                      </div>
                      <input type="hidden" name="product-id" value="${item.product_id }">
                      <input type="hidden" name="section-id" value="template--19220073709745__product_list_3Uyb9k">
                  </form>
                </product-form-component>
              </div>
            </div>
          </div>
        </div>
      </div>
      </li>
    `;
    })
    .join("");

  // Add a check to ensure the element is not null before setting innerHTML
  if (wishlistBlock) {
    wishlistBlock.innerHTML = '<div class="tab-content active"><ul class="resource-list--grid product-grid contains-card contains-card--product" role="list">'+wishlistHtml+'</ul></div>';
  } else {
    //console.error('Element with class "js-wishlistBlock" not found');
  }
  //}
}

// Execute this function on DOM content load
jQuery(document).ready(function () {
  setTimeout(function(){
    addedWishListFill();
  },1000);
  // Display wishlist items
  displayWishlist();
});
var recommendTriggered = false;
jQuery(window).scroll(function(){
  if(!recommendTriggered && jQuery('.content-for-layout').find('.related-products.product-recommendations--loaded').length>0){
    var recommendSection = jQuery('.content-for-layout').find('.related-products.product-recommendations--loaded').offset().top
    //console.log("recommendSection",recommendSection);
    addedWishListFill();
    recommendTriggered = true;
  }
});

function addedWishListFill() {
  // Fetch the wishlist data from localStorage
  const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
  console.log("wishlistData",wishlistData);
  // Set the initial button text based on whether the product is in the wishlist or not
  if (jQuery(".wishlist_button").length != 0) {
    const wishlistButton = document.querySelector(".wishlist_button"); // Use querySelector instead of getElementsByClassName
    const producturlArr = [];
    if (wishlistButton) {
      jQuery.each(wishlistData, function (index, product) {
        if (product.product_url != "" && product.product_url != undefined) {
          producturlArr.push(product.product_url);
        }
      });
      jQuery(".wishlist_button").each(function () {
        var productUrlwish = jQuery(this).attr("data-url");
        console.log("xproductUrlwish",productUrlwish);
        var wishStr = "";
        if (jQuery.inArray(productUrlwish, producturlArr) !== -1) {
          wishStr = `<svg class="heart-filled" width="35px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
              </svg>`;
          if (!jQuery("body").hasClass("collection")) {
            //wishStr+=`<p class="wishlist_text">In Your Wishlist</p>`;
          }
        } else {
          wishStr = `<svg width="35px" height="35px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="heart-outline">
              
              <rect x="0" fill="none" width="24" height="24"/>
              
              <g>
              
              <path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/>
              
              </g>
              
              </svg>`;
          if (!jQuery("body").hasClass("collection")) {
           // wishStr+='<p class="wishlist_text">Not In Wishlist</p>';
          }
        }
        jQuery(this).html(wishStr);
      });
    } else {
      console.error('Element with class "wishlist_button" not found');
    }
  }
}
jQuery(document).on("click", ".trial-cart-add-wishlist", function () {
  // Get the `try_cookie_product` cookie
  var match = document.cookie.match(
    new RegExp("(^| )" + "try_cookie_product" + "=([^;]+)")
  );
  var productData = match ? JSON.parse(match[2]) : [];

  if (productData && productData.length > 0) {
    var removeVariantId = jQuery(this).attr("remove-variantid");
    var productId = jQuery(this).attr("remove-pid");

    // Loop through productData and add to wishlist/remove from productData
    jQuery.each(productData, function (index, product) {
      if (product.product_id == productId) {
        let wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
        wishlistData.push(product);
        localStorage.setItem("wishlist", JSON.stringify(wishlistData));

        // Remove the product from productData
        productData.splice(index, 1);

        // Break the loop since the product is found and removed
        return false;
      }
    });

    removeArrayElement(tyrHomeProductArr, "variant_id", removeVariantId);

    // Update the `try_cookie_product` cookie with the modified data
    setCookie("try_cookie_product", "", -1);
    setCookie("try_cookie_product", JSON.stringify(productData), 1);

    // Update the cart item list and UI
    trycartItemList();
    jQuery(".custom-head-trial").text(
      "HOME TRIAL CART (" + productData.length + ")"
    );

    if (productData.length == 0) {
      $(".main-drawer_footer").hide();
      if (jQuery("#total_cart").val() > 0) {
      } else {
        $(".header-and-progress").hide();
        $(".cart-home-wrapper").hide();
      }
    }

    // Show notification and update buttons
    notify("Design Added to favourite", "error");
    jQuery(".trialbtn_" + productId).hide();
    jQuery(".addedbtn_" + productId).show();
    displayWishlist();
  }
});

jQuery(document).on("click", ".cart-add-move-wishlist", function () {
  var variantId = jQuery(this).attr("data-variantid");
  removeCartProductMoveWishlist(variantId);
  toggleWishlist(jQuery(this), 1);
  jQuery("#CartDrawer-CartItems")
    .find('[data-remove="' + variantId + '"]')
    .trigger("click");
});

/***************** Wishlist Code end here *****************/

// PRODUCT ANIMATION IMAGE -- START
window.addEventListener('scroll', function() {
    const triggerElement = document.querySelector('.product_big_namebg');
    const targetElement = document.querySelector('.animation_img_col');
    if (!triggerElement || !targetElement) return;
    const triggerPosition = triggerElement.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;
    const triggerPercent = (triggerPosition / windowHeight) * 100;
    if (triggerPercent <= 50 && triggerPercent >= 15) {
        targetElement.classList.add('active_big');
    }
    else if (triggerPercent < 15 || triggerPercent > 50) {
        targetElement.classList.remove('active_big');
    }
});
// PRODUCT ANIMATION IMAGE -- END

// HERO BANNER SLIDER -- START
$(document).ready(function(){
  var $slider = $('.advherslideshow').slick({
    arrows: false,
    dots: false,
    infinite: true,
    fade: true,
    speed: 1000, 
  });
  // On init, add animate-in to first slide
  $('.advherslideshow .slick-current .advs-mainbox').addClass('animate-in');
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.advs-mainbox').removeClass('animate-in');
  });
  $slider.on('afterChange', function(event, slick, currentSlide){
    $('.advherslideshow .slick-current .advs-mainbox').addClass('animate-in');
  });
  // Custom button
  $('.advs-button').on('click', function(e){
    e.preventDefault();
    $slider.slick('slickNext');
  });
});
// HERO BANNER SLIDER -- END

// PRODUCT CONTENT SLIDER -- START
var swiper = new Swiper(".product_content_slider", {
  effect: 'fade', // 👈 Fade effect added
  fadeEffect: {
    crossFade: true, // Optional: enables cross fade
  },
  loop: true,
  spaceBetween: 0,
  centeredSlides: true,
  pagination: {
    el: ".pc_swiper-pagination",
    type: "bullets",
    clickable: true,
  },
  navigation: {
    nextEl: ".pc_swiper-button-next",
    prevEl: ".pc_swiper-button-prev",
  },
  // on: {
  //   init: function () {
  //     updateFraction(this);
  //   },
  //   slideChange: function () {
  //     updateFraction(this);
  //   },
  // },
});

// function updateFraction(swiper) {
//   const current = swiper.realIndex + 1;
//   const total = swiper.slides.length;
//   document.querySelector(".pc_swiper-fraction").innerHTML = `${current} / ${total}`;
// }

$('.product_content_images .pc_trigger_img').on('click', function() {
    $('.pc_swiper-button-next').trigger('click');
});


// PRODUCT CONTENT SLIDER -- END

// PRODUCT ATC STICKY -- START

document.addEventListener("DOMContentLoaded", function () {
  const atcMain = document.querySelector(".product_atc_main");
  const atcSticky = document.querySelector(".product_atc_sticky");

  if (!atcMain || !atcSticky) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Agar .product_atc_main visible hai
          atcSticky.classList.remove("product_atc_sticky");
        } else {
          // Agar visible nahi hai
          atcSticky.classList.add("product_atc_sticky");
        }
      });
    },
    {
      root: null, // viewport
      threshold: 0, // jaise hi element screen se nikalta hai
    }
  );

  observer.observe(atcMain);
});

// PRODUCT ATC STICKY -- END

// START :: CART PROGRESS
var goalAmount = jQuery('.cc-cart-progress').attr('data-goal-amount');
var goalBeforeText = jQuery('.cc-cart-progress').attr('data-before-amount-text');
var goalAfterText = jQuery('.cc-cart-progress').attr('data-after-amount-text');
var goalReachText = jQuery('.cc-cart-progress').attr('data-goal-reached-text');
setInterval(function(){
 //if(jQuery('.drawer.active').length>0){
   jQuery.getJSON('/cart.js', function(cart) {
      let cartData = cart.items;
      let cartstr = '';
      let subTotal = 0;
      var cartCounter=0;
      let totalCart = cartData.length;
      if (cart.items.length === 1) {
        var quantity = cartData[0].quantity;
        var product_handle = cartData[0].handle;
        var variantTitle = cartData[0].variant_title;
        var lineItemKey = cartData[0].key;
        var productId = cartData[0].product_id;
        if(cartData[0].selling_plan_allocation!=undefined){
          jQuery('.cart-drawer').find('.Subscription-container').hide();
        }
        if(quantity==1){
          fetch('/products/' + product_handle + '.js')
            .then(response => response.json())
            .then(data => {
              if(data.selling_plan_groups.length>0){
                if(jQuery('.Subscription-container').find('#upgrade_subscription').is(":checked") && cartData[0].selling_plan_allocation==undefined){
                  if(variantTitle!="" && variantTitle!=undefined){
                    variantTitle = variantTitle.toLowerCase();
                    var subscriptionTitle = '1 month';
                    if(variantTitle!='default title'){
                      if(variantTitle=='2-pack'){
                        subscriptionTitle = '2 month';
                      }else if(variantTitle=='3-pack'){
                        subscriptionTitle = '3 month';
                      }else if(variantTitle=='4-pack'){
                        subscriptionTitle = '4 month';
                      }
                    }
                    for (let r = 0; r < data.selling_plan_groups.length; r++) {
                      var planName = data.selling_plan_groups[r].name;
                      if (planName.indexOf(subscriptionTitle) !== -1) {
                        var planId = data.selling_plan_groups[r].selling_plans[0].id;
                        cartUpdateData(lineItemKey,planId);
                      }
                    }
                }
              }
            }else{
              jQuery('.cart-drawer').find('.Subscription-container').hide();
            }
          });
        }
      }else if(cart.items.length>1){
        jQuery('.cart-drawer').find('.Subscription-container').hide();
      }

      if(cartData.length>0){
        for(var k=0;k<cartData.length;k++){
          var productId = cartData[k].product_id;
          if(jQuery('.product__info-wrapper .routine_product_block').find('.routine_product_col[data-col-pid="'+productId+'"]').length>0){
            jQuery('.product__info-wrapper .routine_product_block').find('.routine_product_col[data-col-pid="'+productId+'"]').hide();
          }
          //console.log("productId",productId);
          if(jQuery('.cart-drawer .other_flavor').find('.other_flavor-card[data-col-pid="'+productId+'"]').length>0){
            jQuery('.cart-drawer .other_flavor').find('.other_flavor-card[data-col-pid="'+productId+'"]').hide();
          }
        }
        if(jQuery('.drawer.active').length>0){
          subTotal = cart.original_total_price;
          var percentage_reached = (eval(subTotal) / eval(goalAmount));
          if(parseFloat(percentage_reached) > 100){
            var percentage_reached = 100;
          }
          jQuery('.cc-cart-progress-fill').css("width", Math.round(percentage_reached)+"%");
          jQuery('.cc-cart-progress-fill span').html(Math.round(percentage_reached)+"%");
        
          jQuery('.cc-cart-progressbar').removeClass("progress-filled");
          jQuery('.cart_shipping_box').hide();
          if(percentage_reached == 100){
            jQuery('.cart_shipping_box').show();
            jQuery('.cc-cart-progressbar').addClass("progress-filled");
          }else{
            jQuery('.cart_shipping_box').hide();
          }
          
        
          var cartTotalFull = eval(subTotal) / 100;
          var tempStr = '';
          var svg='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M5.24016 16.4266C4.63349 16.4266 4.11932 16.2149 3.69766 15.7916C3.27543 15.3677 3.06432 14.853 3.06432 14.2474H1.91016V6.0099C1.91016 5.62656 2.03877 5.30656 2.29599 5.0499C2.55266 4.79267 2.87293 4.66406 3.25682 4.66406H14.2818V7.67656H16.2052L19.0902 11.5549V14.2474H17.7435C17.7435 14.853 17.5313 15.3677 17.1068 15.7916C16.6824 16.2149 16.1668 16.4266 15.5602 16.4266C14.954 16.4266 14.4402 16.2149 14.0185 15.7916C13.5963 15.3677 13.3852 14.853 13.3852 14.2474H7.42349C7.42349 14.8563 7.21127 15.3718 6.78682 15.7941C6.36182 16.2163 5.84627 16.4266 5.24016 16.4266ZM5.24349 15.5941C5.61849 15.5941 5.93682 15.4635 6.19849 15.2024C6.4596 14.9407 6.59016 14.6224 6.59016 14.2474C6.59016 13.8724 6.4596 13.5543 6.19849 13.2932C5.93738 13.0321 5.61905 12.9016 5.24349 12.9016C4.86793 12.9016 4.54988 13.0321 4.28932 13.2932C4.02821 13.5543 3.89766 13.8724 3.89766 14.2474C3.89766 14.6224 4.02821 14.9405 4.28932 15.2016C4.55043 15.4627 4.86849 15.5941 5.24349 15.5941ZM15.5643 15.5932C15.9393 15.5932 16.2574 15.4627 16.5185 15.2016C16.7796 14.9405 16.9102 14.6224 16.9102 14.2474C16.9102 13.8724 16.7796 13.5543 16.5185 13.2932C16.2574 13.0321 15.9393 12.9016 15.5643 12.9016C15.1893 12.9016 14.8713 13.0321 14.6102 13.2932C14.349 13.5543 14.2185 13.8724 14.2185 14.2474C14.2185 14.6224 14.349 14.9405 14.6102 15.2016C14.8713 15.4627 15.1893 15.5932 15.5643 15.5932ZM14.2818 11.7474H18.2085L15.7568 8.5099H14.2818V11.7474Z" fill="#190B41"/></path></svg>';
          if(goalAmount > cartTotalFull){
            var goalPendingAmount = (eval(goalAmount) * 100) - subTotal;
            tempStr += goalBeforeText;
            tempStr += '<span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
            tempStr += Shopify.formatMoney(goalPendingAmount);
            tempStr += '</span>'
            tempStr += goalAfterText;
          }
          else{
            tempStr += goalReachText;
            svg = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none"><path d="M10.5625 17.2493V10.7507L4.875 7.45763V13.6533C4.875 13.7431 4.89746 13.8273 4.94238 13.9057C4.98715 13.9843 5.05445 14.0516 5.14428 14.1076L10.5625 17.2493ZM11.4375 17.2493L16.8557 14.1076C16.9456 14.0516 17.0129 13.9843 17.0576 13.9057C17.1025 13.8273 17.125 13.7431 17.125 13.6533V7.45763L11.4375 10.7507V17.2493ZM10.2932 18.1007L4.70678 14.8818C4.4857 14.7551 4.31267 14.5828 4.18769 14.3651C4.06256 14.1475 4 13.9119 4 13.6583V7.3417C4 7.08809 4.06256 6.8525 4.18769 6.63492C4.31267 6.41719 4.4857 6.24496 4.70678 6.11823L10.2932 2.89932C10.5143 2.77259 10.7499 2.70923 11 2.70923C11.2501 2.70923 11.4857 2.77259 11.7068 2.89932L17.2932 6.11823C17.5143 6.24496 17.6873 6.41719 17.8123 6.63492C17.9374 6.8525 18 7.08809 18 7.3417V13.6583C18 13.9119 17.9374 14.1475 17.8123 14.3651C17.6873 14.5828 17.5143 14.7551 17.2932 14.8818L11.7068 18.1007C11.4857 18.2274 11.2501 18.2908 11 18.2908C10.7499 18.2908 10.5143 18.2274 10.2932 18.1007ZM14.2476 8.11564L16.6219 6.74932L11.2693 3.65138C11.1794 3.59538 11.0897 3.56739 11 3.56739C10.9103 3.56739 10.8206 3.59538 10.7307 3.65138L8.6375 4.85451L14.2476 8.11564ZM11 9.99863L13.3625 8.62707L7.74063 5.37798L5.37813 6.74932L11 9.99863Z" fill="#242424"/></svg>';
          }
          jQuery('.cart__goal__message').html(tempStr);
          jQuery('.cc-cart-progress-heading .svg-html').html('');
          jQuery('.cc-cart-progress-heading .svg-html').html(svg);
        }
      }
});
 //}
},500);
// END :: CART PROGRESS

// YOU MAY LIKE -- START

$(document).ready(function(){
  sliderUpsell();
});
// YOU MAY LIKE -- END

// HOME BANNER -- START

$(document).ready(function(){
  $('.home_banner_slider').slick({
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9493 8.45734L13.8306 10.348L9.4706 14.688L27.6106 14.7053L27.6079 17.372L9.51726 17.3547L13.8039 21.6613L11.9146 23.5413L4.38926 15.9813L11.9493 8.45734Z" fill="black"/></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0507 8.45734L18.1694 10.348L22.5294 14.688L4.3894 14.7053L4.39207 17.372L22.4827 17.3547L18.1961 21.6613L20.0854 23.5413L27.6107 15.9813L20.0507 8.45734Z" fill="black"/></svg></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    infinite: true,
    fade: true,
    cssEase: 'linear' ,
    autoplay: false,         
    autoplaySpeed: 3000,
    pauseOnHover: false,
    pauseOnFocus: false
  });
});
// HOME BANNER -- END

// MENU DRAWER ACCORDION -- START
document.addEventListener("DOMContentLoaded", function () {
  const firstAccordionItemHeader = document.querySelector(
    ".mdc_accordion_heading"
  );
  const firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;

  firstAccordionItemHeader.classList.add("active");
  firstAccordionItemBody.style.maxHeight =
    firstAccordionItemBody.scrollHeight + "px";

  const accordionItemHeaders = document.querySelectorAll(
    ".mdc_accordion_heading"
  );

  accordionItemHeaders.forEach((accordionItemHeader) => {
    accordionItemHeader.addEventListener("click", (event) => {
      const currentlyActiveAccordionItemHeader = document.querySelector(
        ".mdc_accordion_heading.active"
      );
      if (
        currentlyActiveAccordionItemHeader &&
        currentlyActiveAccordionItemHeader !== accordionItemHeader
      ) {
        currentlyActiveAccordionItemHeader.classList.toggle("active");
        currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
      }
      accordionItemHeader.classList.toggle("active");
      const accordionItemBody = accordionItemHeader.nextElementSibling;
      if (accordionItemHeader.classList.contains("active")) {
        accordionItemBody.style.maxHeight =
          accordionItemBody.scrollHeight + "px";
      } else {
        accordionItemBody.style.maxHeight = 0;
      }
    });
  });
});
// MENU DRAWER ACCORDION -- END

//CART DRAWER UPSELL PRODUCT SLIDER AND ADD TO CART JS START
jQuery(document).on("click",".cart-drawer .header-actions__action",function(){
  setTimeout(function(){
    upsellSliderCart();
  },10);
});
let totalSlideUpsell = 0;
let ignoreSlideCount = 0;

function upsellSliderCart() {
  var sliderId = setInterval(function() {
    var $drawer = jQuery('.cart-drawer__dialog.dialog-drawer');
    var $slider = $drawer.find('.other_flavor_grid');

    if ($drawer.attr('open') !== undefined && $slider.length) {
      sliderUpsell();
      // collect indexes to remove
      var indexesToRemove = [];
      $slider.find('.other_flavor-card.ignore-slide').each(function() {
        var index = jQuery(this).closest('.slick-slide').attr('data-slick-index');
        if (index !== undefined) {
          indexesToRemove.push(parseInt(index));
        }
      });

      // remove in descending order
      indexesToRemove.sort(function(a, b){ return b - a; });
      indexesToRemove.forEach(function(i) {
        $slider.slick('slickRemove', i);
      });

      // Refresh or destroy slick if needed
      if ($slider.hasClass('slick-initialized')) {
        const remainingSlides = $slider.find('.slick-slide').not('.slick-cloned').length;

        if (remainingSlides <= 1) {
          $slider.slick('unslick');
        } else {
          $slider.slick('setPosition');
        }
      }

      clearInterval(sliderId);
    }

    hideshowUpsell();
  }, 10);
}

function hideshowUpsell(){
  if(jQuery('.cart-drawer__summary').find('.other_flavor_grid').length>0) {
    totalSlideUpsell = jQuery('.cart-drawer__summary').find('.other_flavor_grid').slick('getSlick').slideCount;
    ignoreSlideCount = jQuery('.cart-drawer__summary').find('.other_flavor-card.ignore-slide').length;
    var countShow = jQuery('.cart-drawer__summary').find('.other_flavor-card:not(.ignore-slide)').length;
    //console.log("countShow",countShow,ignoreSlideCount);
    jQuery('.cart-drawer__summary').find('.other_flavor').show();
    if(countShow<=1){
      if(countShow == 0){
        if(jQuery('.cart-drawer__summary').find('.other_flavor').length>0){
          jQuery('.cart-drawer__summary').find('.other_flavor').hide();
        }       
      }
    }
  }
}

jQuery(document).on("click",".cart-items__wrapper .cart-items__remove",function(){
  setTimeout(function(){
    upsellSliderCart();
  },1500);
});

jQuery(document).on("click",".cart-items__wrapper .quantity-minus,.cart-items__wrapper .quantity-plus",function(){
  var otherflavorId = setInterval(function(){
    if(!jQuery('.cart-drawer__dialog').find('.other_flavor_grid').hasClass('slick-initialized')) {
      sliderUpsell();
      clearInterval(otherflavorId);
    }
  },500);
});

function sliderUpsell(){
  if(jQuery('.cart-drawer__dialog').find('.other_flavor_grid').length>0){
    if(jQuery('.cart-drawer__dialog').find('.other_flavor_grid').hasClass('slick-initialized')) {
      jQuery('.cart-drawer__dialog').find('.other_flavor_grid').slick('unslick');
    }

    jQuery('.cart-drawer__dialog').find('.other_flavor_grid').slick({
      dots: false,
      arrows: true,
      prevArrow:
        '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9493 8.45734L13.8306 10.348L9.4706 14.688L27.6106 14.7053L27.6079 17.372L9.51726 17.3547L13.8039 21.6613L11.9146 23.5413L4.38926 15.9813L11.9493 8.45734Z" fill="black"/></svg></button>',
      nextArrow:
        '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0507 8.45734L18.1694 10.348L22.5294 14.688L4.3894 14.7053L4.39207 17.372L22.4827 17.3547L18.1961 21.6613L20.0854 23.5413L27.6107 15.9813L20.0507 8.45734Z" fill="black"/></svg></button>',
      infinite: false,
      slidesToShow: 1.3,
      slidesToScroll: 1
    });
  }
}


/* CART DRAWER UPSELL */
jQuery(document).on("click", ".other_flavor_grid .routine_product_btn.routine_add_Cart", function (e) {
  var pid = jQuery(this).attr('data-pid');
  //console.log("pid",pid);
  jQuery(this).hide();
  jQuery(this).addClass("btn--loading");
  var vid = parseInt(jQuery(this).attr("data-vid"));
  var data = {};
  var dataType = [];
  data["id"] = vid;
  data["quantity"] = 1;
  dataType.push(data);
  const newData = {
    items: dataType,
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: newData,
    dataType: "json",
    success: function (data) {
      //console.log("data",data);
      if(jQuery('.other_flavor_grid').find('.other_flavor-card[data-col-pid="'+pid+'"]').length>0){
        jQuery('.other_flavor_grid').find('.other_flavor-card[data-col-pid="'+pid+'"]').removeClass('slide-main');
        jQuery('.other_flavor_grid').find('.other_flavor-card[data-col-pid="'+pid+'"]').addClass('ignore-slide');
      }
      refreshCartDrawer();
    },
  });

  setTimeout(function () {
    jQuery(".add__btn_custom__upsell").show();
    jQuery(".add__custom_loader").hide();
    jQuery('[cart-product--id="' + pid + '"]').hide();
  }, 1550);
});

function refreshCartDrawer() {
  jQuery.get('/cart?view=drawer', function(html) {
    var $currentTable = jQuery('.cart-drawer__dialog .cart-items__table');

    if ($currentTable.length) {
      // Update cart rows (exclude header)
      var $newRows = jQuery(html)
        .find('.cart-items__table-row')
        .not(':has(th)');

      $currentTable.find('.cart-items__table-row').not(':has(th)').remove();
      $currentTable.append($newRows);
    }

    // Update totals
    var $newTotals = jQuery(html).find('.cart__summary-totals');
    var $currentTotals = jQuery('.cart__summary-totals');
    if ($newTotals.length && $currentTotals.length) {
      $currentTotals.replaceWith($newTotals);
    }
    jQuery.getJSON('/cart.js', function(cart) {
      var totalQuantity = cart.item_count;     // total items (sum of quantities)
      var totalProducts = cart.items.length;   // total unique products
      if(jQuery('.cart-drawer__header').find('.cart-bubble__text-count').length>0){
        jQuery('.cart-drawer__header').find('.cart-bubble__text-count').text('('+totalQuantity+')');
      }
    });
    // Reinitialize quantity selectors and sliders
    reinitQuantitySelectors();
    
  });
  setTimeout(function(){
    upsellSliderCart();
    //hideshowUpsell();
  },1000);
}

function reinitQuantitySelectors() {
  jQuery('.cart-drawer__dialog quantity-selector-component').each(function() {
    // your theme may have a global function to initialize them
    if (typeof this.connectedCallback === 'function') {
      this.connectedCallback(); // triggers web component init
    }
  });
}

/* CART DRAWER UPSELL */
//CART DRAWER UPSELL PRODUCT SLIDER AND ADD TO CART JS END

// BANNER SLIDER -- START
$(document).ready(function(){
  $('.banner__slider_main').slick({
    dots: true,
    arrows: true,
    prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9493 8.45734L13.8306 10.348L9.4706 14.688L27.6106 14.7053L27.6079 17.372L9.51726 17.3547L13.8039 21.6613L11.9146 23.5413L4.38926 15.9813L11.9493 8.45734Z" fill="black"/></svg></button>',
    nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0507 8.45734L18.1694 10.348L22.5294 14.688L4.3894 14.7053L4.39207 17.372L22.4827 17.3547L18.1961 21.6613L20.0854 23.5413L27.6107 15.9813L20.0507 8.45734Z" fill="black"/></svg></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    infinite: true,
    fade: true,
    cssEase: 'linear' ,
    autoplay: false,         
    autoplaySpeed: 3000,
    pauseOnHover: false,
    pauseOnFocus: false
  });
});
// BANNER SLIDER -- END

//PROGRESSBAR CART DRAWER JS STARTED
function getProgressData() {
   $.ajax({
    url: "/cart",
    dataType: "json",
    error: function (items) {
      //console.error(items[0]);
      //loadingBarTrigger("done");
    },
    success: function (cart) {
      if (jQuery('.cart__drawer').find('.cart-drawer__header').length > 0) {
        var objAttr = jQuery('.cart__drawer').find('.cart-drawer__header');
        var goal1    = parseInt(objAttr.attr('data-goal1'));
        var goal2    = parseInt(objAttr.attr('data-goal2'));
        var goal3    = parseInt(objAttr.attr('data-goal3'));
        var goal4    = parseInt(objAttr.attr('data-goal4'));

        var goalmsg1 = objAttr.attr('data-goal-msg1');
        var goalmsg2 = objAttr.attr('data-goal-msg2');
        var goalmsg3 = objAttr.attr('data-goal-msg3');
        var goalmsg4 = objAttr.attr('data-goal-msg4');

        var goalmsgp1 = objAttr.attr('data-goal-pmsg1');
        var goalmsgp2 = objAttr.attr('data-goal-pmsg2');
        var goalmsgp3 = objAttr.attr('data-goal-pmsg3');
        var goalmsgp4 = objAttr.attr('data-goal-pmsg4');

        var totalCart = cart.original_total_price;
        var drawerObj = '';
        if(jQuery('.cart__drawer').find('.cf-progress-wrapper').length>0){
          drawerObj = jQuery('.cart__drawer').find('.cf-progress-wrapper');
          drawerObj.find('.cf-step').addClass('cf-locked');
          drawerObj.find('.cf-step').removeClass('cf-unlocked');
        }
        var progressWidth = 0;
        // --- Goal 1 ---
        console.log("total cart",totalCart,goal1);
        var msgfree = goal1;
        var msgfreep = goalmsgp1;
        if (totalCart <= goal1) {
          console.log("goal1 less",goal1);
          progressWidth = (totalCart / goal1) * 100;
          drawerObj.find('.cf-step.cf-step-buy2').addClass('cf-unlocked');
          drawerObj.find('.cf-step.cf-step-buy2').removeClass('cf-locked');
          msgfree = goalmsg1;
          msgfreep = goalmsgp1;
        }
        // --- Between Goal 1 and Goal 2 ---
        else if (totalCart > goal1 && totalCart <= goal2) {
          progressWidth = 10 + ((totalCart - goal1) / (goal2 - goal1)) * 25;
          console.log("goal1",goal2);
          if(drawerObj!=""){
            drawerObj.find('.cf-step.cf-step-shipping').addClass('cf-unlocked');
            drawerObj.find('.cf-step.cf-step-shipping').removeClass('cf-locked');
            if(totalCart == goal2){
              drawerObj.find('.cf-step.cf-step-buy2').addClass('cf-unlocked');
              drawerObj.find('.cf-step.cf-step-buy2').removeClass('cf-locked');
              msgfree = goalmsg3;
              msgfreep = goalmsgp2;
            }else{
              msgfree = goalmsg2;
              msgfreep = goalmsgp1;
            }
          }

        }
        // --- Between Goal 2 and Goal 3 ---
        else if (totalCart > goal2 && totalCart <= goal3) {
          progressWidth = 45 + ((totalCart - goal2) / (goal3 - goal2)) * 25;
          console.log("goal2",goal2);
          drawerObj.find('.cf-step.cf-step-shipping').addClass('cf-unlocked');
          drawerObj.find('.cf-step.cf-step-shipping').removeClass('cf-locked');
          drawerObj.find('.cf-step.cf-step-buy2').addClass('cf-unlocked');
          drawerObj.find('.cf-step.cf-step-buy2').removeClass('cf-locked');
          msgfree = goalmsg3;
          msgfreep = goalmsgp2;
        }
        // --- Between Goal 3 and Goal 4 ---
        else if (totalCart > goal3 && totalCart <= goal4) {
          console.log("goal3",goal3);
          progressWidth = 75 + ((totalCart - goal3) / (goal4 - goal3)) * 25;
          drawerObj.find('.cf-step.cf-step-shipping').addClass('cf-unlocked');
          drawerObj.find('.cf-step.cf-step-shipping').removeClass('cf-locked');
          drawerObj.find('.cf-step.cf-step-buy2').addClass('cf-unlocked');
          drawerObj.find('.cf-step.cf-step-buy2').removeClass('cf-locked');
          drawerObj.find('.cf-step.cf-step-five').eq(0).addClass('cf-unlocked');
          drawerObj.find('.cf-step.cf-step-five').eq(0).removeClass('cf-locked');
          msgfree = goalmsg4;
          msgfreep = goalmsgp3;
        }
        // --- Reached Goal 4 (Max) ---
        else if (totalCart >= goal4) {
          console.log("goal4",goal4);
          progressWidth = 100;
          drawerObj.find('.cf-step.cf-step-shipping').addClass('cf-unlocked');
          drawerObj.find('.cf-step.cf-step-shipping').removeClass('cf-locked');
          drawerObj.find('.cf-step.cf-step-buy2').addClass('cf-unlocked');
          drawerObj.find('.cf-step.cf-step-buy2').removeClass('cf-locked');
          drawerObj.find('.cf-step.cf-step-five').addClass('cf-unlocked');
          drawerObj.find('.cf-step.cf-step-five').removeClass('cf-locked');
          msgfree = goalmsg4;
          msgfreep = goalmsgp4;
        }

        console.log("Progress:", progressWidth);
        if(jQuery('.cart__drawer').find('.cf-progress-wrapper .cf-progress-fill').length>0){
          jQuery('.cart__drawer').find('.cf-progress-wrapper .cf-progress-fill').css("width", progressWidth + "%");
          jQuery('.cart__drawer').find('.cf-ship-text').text(msgfree);
          jQuery('.cart__drawer').find('.cf-ship-text_header').html(msgfreep);
        }
      }
    }
  });
}


jQuery(document).ready(function($){
    setInterval(function(){
     //getProgressData();
    },500);
});

//PROGRESSBAR CART DRAWER JS END